import { token } from '@zillow/constellation';
import styled from 'styled-components';

const DEFAULT_SIZE = '8px';

export const StyledDiv = styled.div`
  width: ${DEFAULT_SIZE};
  height: ${DEFAULT_SIZE};
  border-radius: ${DEFAULT_SIZE};
  background-color: ${token('colors.orangeRed400')};
`;
